// Theme: paper
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'paper',
  name: 'PAPER',
  tagline: 'PAPER',
  description: 'Caderno analogico. Creme quente com tinta sepia.',
  category: 'minimal-atmosphere',
  tier: 'common',
  basePrice: 150,
  swatches: ['#FDF5ED', '#955A00', '#FBF1E7', '#180C06'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '10px',
      '--shadow-card': '0 8px 26px rgba(24, 12, 6, 0.18)',
      '--shadow-card-active': '0 10px 34px color-mix(in srgb, var(--primary) 12%, transparent)'
    },
    shellClasses: 'font-sans theme-paper'
  },
  colorVars: {
    '--accent': '#955A00',
    '--accent-foreground': 'oklch(0.99 0.005 36)',
    '--background': '#FDF5ED',
    '--border': '#E0D4C8',
    '--card': '#FBF1E7',
    '--card-border-active': 'rgba(149, 90, 0, 0.22)',
    '--card-completed': '#F5E8D4',
    '--card-foreground': '#1B0E08',
    '--card-glow': 'rgba(149, 90, 0, 0.05)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#BA2B2E',
    '--destructive-foreground': 'oklch(0.99 0.005 36)',
    '--foreground': '#180C06',
    '--hold-fill': '#955A00',
    '--input': '#E0D4C8',
    '--modal-bg': '#FDF5ED',
    '--modal-border': '#E0D4C8',
    '--modal-overlay-bg': 'rgba(24, 12, 6, 0.55)',
    '--modal-shadow': '0 8px 26px rgba(24, 12, 6, 0.18)',
    '--muted': '#ECE3D9',
    '--muted-foreground': '#5C5047',
    '--nav-active': '#955A00',
    '--nav-bg': '#F8EEE4',
    '--popover': '#FBF1E7',
    '--popover-foreground': '#1B0E08',
    '--premium': '#6731A8',
    '--primary': '#955A00',
    '--primary-foreground': 'oklch(0.99 0.005 36)',
    '--ring': '#955A00',
    '--secondary': '#E8DED3',
    '--secondary-foreground': '#2F241D',
    '--streak': '#955A00',
    '--success': '#186A23',
    '--success-foreground': 'oklch(0.99 0.005 36)',
    '--xp': '#955A00',
    '--xp-bg': '#F3E8DA'
  },
  resolvedVars: {
    '--accent': '#955A00',
    '--accent-foreground': 'oklch(0.99 0.005 36)',
    '--accent-foreground-hsl': '30 80% 96%',
    '--accent-foreground-oklch': '0.99 0.005 36',
    '--accent-hsl': '36 100% 29%',
    '--accent-oklch': 'from #955A00 l c h',
    '--background': '#FDF5ED',
    '--background-hsl': '30 80% 96%',
    '--background-oklch': 'from #FDF5ED l c h',
    '--border': '#E0D4C8',
    '--border-hsl': '30 28% 83%',
    '--border-oklch': 'from #E0D4C8 l c h',
    '--border-w': '2px',
    '--card': '#FBF1E7',
    '--card-border-active': 'rgba(149, 90, 0, 0.22)',
    '--card-completed': '#F5E8D4',
    '--card-completed-hsl': '36 62% 90%',
    '--card-completed-oklch': 'from #F5E8D4 l c h',
    '--card-foreground': '#1B0E08',
    '--card-foreground-hsl': '19 54% 7%',
    '--card-foreground-oklch': 'from #1B0E08 l c h',
    '--card-glow': 'rgba(149, 90, 0, 0.05)',
    '--card-hsl': '30 71% 95%',
    '--card-oklch': 'from #FBF1E7 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#BA2B2E',
    '--destructive-foreground': 'oklch(0.99 0.005 36)',
    '--destructive-foreground-hsl': '30 80% 96%',
    '--destructive-foreground-oklch': '0.99 0.005 36',
    '--destructive-hsl': '359 62% 45%',
    '--destructive-oklch': 'from #BA2B2E l c h',
    '--foreground': '#180C06',
    '--foreground-hsl': '20 60% 6%',
    '--foreground-oklch': 'from #180C06 l c h',
    '--hold-fill': '#955A00',
    '--hold-fill-hsl': '36 100% 29%',
    '--hold-fill-oklch': 'from #955A00 l c h',
    '--input': '#E0D4C8',
    '--input-hsl': '30 28% 83%',
    '--input-oklch': 'from #E0D4C8 l c h',
    '--modal-bg': '#FDF5ED',
    '--modal-bg-hsl': '30 80% 96%',
    '--modal-bg-oklch': 'from #FDF5ED l c h',
    '--modal-border': '#E0D4C8',
    '--modal-border-hsl': '30 28% 83%',
    '--modal-border-oklch': 'from #E0D4C8 l c h',
    '--modal-overlay-bg': 'rgba(24, 12, 6, 0.55)',
    '--modal-shadow': '0 8px 26px rgba(24, 12, 6, 0.18)',
    '--muted': '#ECE3D9',
    '--muted-foreground': '#5C5047',
    '--muted-foreground-hsl': '26 13% 32%',
    '--muted-foreground-oklch': 'from #5C5047 l c h',
    '--muted-hsl': '32 33% 89%',
    '--muted-oklch': 'from #ECE3D9 l c h',
    '--nav-active': '#955A00',
    '--nav-active-hsl': '36 100% 29%',
    '--nav-active-oklch': 'from #955A00 l c h',
    '--nav-bg': '#F8EEE4',
    '--nav-bg-hsl': '30 59% 93%',
    '--nav-bg-oklch': 'from #F8EEE4 l c h',
    '--popover': '#FBF1E7',
    '--popover-foreground': '#1B0E08',
    '--popover-foreground-hsl': '19 54% 7%',
    '--popover-foreground-oklch': 'from #1B0E08 l c h',
    '--popover-hsl': '30 71% 95%',
    '--popover-oklch': 'from #FBF1E7 l c h',
    '--premium': '#6731A8',
    '--premium-foreground': 'oklch(0.99 0.005 36)',
    '--premium-foreground-hsl': '30 80% 96%',
    '--premium-foreground-oklch': '0.99 0.005 36',
    '--premium-hsl': '267 55% 43%',
    '--premium-oklch': 'from #6731A8 l c h',
    '--primary': '#955A00',
    '--primary-foreground': 'oklch(0.99 0.005 36)',
    '--primary-foreground-hsl': '30 80% 96%',
    '--primary-foreground-oklch': '0.99 0.005 36',
    '--primary-hsl': '36 100% 29%',
    '--primary-oklch': 'from #955A00 l c h',
    '--radius': '10px',
    '--rarity-epic': '#6F3BB2',
    '--rarity-epic-hsl': '266 50% 46%',
    '--rarity-epic-oklch': 'from #6F3BB2 l c h',
    '--rarity-legendary': '#A76C12',
    '--rarity-legendary-hsl': '36 81% 36%',
    '--rarity-legendary-oklch': 'from #A76C12 l c h',
    '--rarity-rare': '#1C50A7',
    '--rarity-rare-hsl': '218 71% 38%',
    '--rarity-rare-oklch': 'from #1C50A7 l c h',
    '--rarity-secret': '#A20519',
    '--rarity-secret-hsl': '352 94% 33%',
    '--rarity-secret-oklch': 'from #A20519 l c h',
    '--ring': '#955A00',
    '--ring-hsl': '36 100% 29%',
    '--ring-oklch': 'from #955A00 l c h',
    '--secondary': '#E8DED3',
    '--secondary-foreground': '#2F241D',
    '--secondary-foreground-hsl': '23 24% 15%',
    '--secondary-foreground-oklch': 'from #2F241D l c h',
    '--secondary-hsl': '31 31% 87%',
    '--secondary-oklch': 'from #E8DED3 l c h',
    '--shadow-card': '0 8px 26px rgba(24, 12, 6, 0.18)',
    '--shadow-card-active': '0 10px 34px color-mix(in srgb, var(--primary) 12%, transparent)',
    '--streak': '#955A00',
    '--streak-hsl': '36 100% 29%',
    '--streak-oklch': 'from #955A00 l c h',
    '--success': '#186A23',
    '--success-foreground': 'oklch(0.99 0.005 36)',
    '--success-foreground-hsl': '30 80% 96%',
    '--success-foreground-oklch': '0.99 0.005 36',
    '--success-hsl': '128 63% 25%',
    '--success-oklch': 'from #186A23 l c h',
    '--tint-primary-subtle': 'hsla(36 100% 29% / 0.15)',
    '--xp': '#955A00',
    '--xp-bg': '#F3E8DA',
    '--xp-bg-hsl': '34 51% 90%',
    '--xp-bg-oklch': 'from #F3E8DA l c h',
    '--xp-hsl': '36 100% 29%',
    '--xp-oklch': 'from #955A00 l c h'
  }
}
